import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type DirectionType, type DirectionBreakpointType, directionList } from '../../typings/directionType';
import { BreakpointDepended } from '../breakpointDepended';
import { defaults } from '../defaults';

export const withDirectionProps = {
  /**
   * Justowanie elementu (flex)
   */
  direction: {
    type: [String, Object] as PropType<DirectionType | DirectionBreakpointType>,
    default: defaults.flex.direction
  }
};

/**
 * Zwraca klasy justowania (flex)
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withSizeProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useDirectionProps = (prefix: string, props: ExtractPropTypes<typeof withDirectionProps>) => {
  return computed(() => {
    if (typeof props.direction === 'string') {
      return `${prefix}--direction-${props.direction}`;
    }
    if (BreakpointDepended(props.direction).value) {
      return `${prefix}--direction-${BreakpointDepended(props.direction).value}`;
    }
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesDirectionArgs = {
  args: {
    direction: defaults.flex.direction
  },

  argTypes: {
    direction: {
      options: directionList,
      control: { type: 'inline-radio' }
    }
  }
};
